import PropTypes from "prop-types";
import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Spinner,
} from "reactstrap";
import {
    ErrorModal,
    RavenAgTable,
    ApproveModalWithParams
} from "components/Common/CombinedComponents";
import {
    getBooleanValue,
    getListItemParameter,
    currencyFormatControl,
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
import {
    getPayFacCommissionBankListByUserName,
    merchantCommissionListApiError,
    getPayFacCommissionsByPricingTableGuidAndMerchantGuid,
    insertMerchantCommissions,
    updateMerchantCommissions,
    getCurrencyListSync,
} from "store/actions";
import { MerchantCommissionForm } from "./MerchantCommissionForm";
let newData = [];
class MerchantCommissionList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recordList: [],
            recordBankList: [],
            recordProgramList: [],
            record: "",
            question: "",
            deleteModal: false,
            addAnother: false,
            isEdit: false,
            isDetail: false,
            selectedBankNetworkGuid: 0,
            selectedPaymentNetworkName: "",
            updateModal: false,
            installmentModal: false,
            approveModal: false,
            radioValue: false,
            buttonView: false,
            values: [],
            recordcolumns: [

                {
                    headerName: this.props.t("bankName"),
                    field: "bankGuid",
                    valueFormatter: params => getListItemParameter(params, this.props.recordBankList, "bankName"),
                    filterParams: {
                        valueFormatter: params =>
                            getListItemParameter(params, this.props.recordBankList, "bankName"),
                    }
                },
                {
                    headerName: this.props.t("reflectToMerchant"),
                    field: "reflectStatus",
                    cellRenderer: "activePassiveCellRender",
                    valueFormatter: getBooleanValue,
                    filterParams: { valueFormatter: getBooleanValue },
                },

            ],
            bankCommissionrecordcolumns: [

                {
                    headerName: this.props.t("installmentId"),
                    field: "installmentId"
                },
                {
                    headerName: this.props.t("morparaCommissionRate"),
                    field: "payFacInstallmentRate",
                    cellStyle: { backgroundColor: 'lightgray', borderRightColor: '#e2e2e2' },
                },
                {
                    headerName: this.props.t("reflectToMerchantCommissionRate"),
                    field: "reflectToMerchantCommissionRate",
                    editable: (params) => params.data.installmentId === 1 ? false : this.state.radioValue,
                    cellStyle: params => {
                        if (params.data.installmentId === 1) {
                            return { backgroundColor: 'lightgray', borderRightColor: '#e2e2e2' };
                        }
                        return null;
                    },
                },
                {
                    headerName: this.props.t("reflectToMerchantCommissionAmount"),
                    field: "reflectToMerchantCommissionAmount",
                    cellStyle: { backgroundColor: 'lightgray', borderRightColor: '#e2e2e2' },
                },
                {
                    headerName: this.props.t("transferToAccount"),
                    field: "transferToAccountAmountTL",
                    cellStyle: { backgroundColor: 'lightgray', borderRightColor: '#e2e2e2', fontWeight: 'bold' },
                },

            ],
        };

        this.toggle = this.toggle.bind(this);
        this.installmentToggle = this.installmentToggle.bind(this);
        this.handleCommissionDefClick = this.handleCommissionDefClick.bind(this);
        this.tableChangedData = createRef();
        this.tableChangedData.current = new Map([]);
        this.formSubmitButtonRef = createRef();
        this.lastUpdateData = createRef();
        this.cellEditorSelector = this.cellEditorSelector.bind(this);


    }

    componentDidMount() {
        this.props.apiError("");
        const {
            onGetBankList,
            onGetRecordList,
            onGetCurrencyRecordList
        } = this.props;

        let req = {
            userName: localStorage.getItem("username"),
        }
        onGetBankList(localStorage.getItem("username"));
        
        onGetRecordList(req);
        onGetCurrencyRecordList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { error, recordList } = this.props;

        if (prevProps.error !== error) {
            this.setState({ error: error });
        }
        if (prevProps.recordList !== this.props.recordList) {

            recordList.forEach(item => {
                item.reflectStatus = item.merchantCommissionGuid != 0 ? true : false;
            });
        }

    }

    handleCommissionDefClick = record => {

        let check = record.merchantCommissionGuid != 0 ? true : false;
        this.setState({ isEdit: check, radioValue: check });
        newData = this.dataTableDataFill(record);
        this.setState({ record: record });
        this.setState({ installmentModal: true });
    };


    getBankNameByGuid(guid) {
        let array = this.props.recordBankList
            .filter(i => i.guid === guid)
            .map(x => x);
        if (array?.length) return array[0].bankName;
        else return guid;
    }

    toggle() {
        this.setState(prevState => ({ modal: !prevState.modal }));
        if (this.state.modal) {
            setTimeout(() => this.setState({ isDetail: false }), 150);
        }
    }

    installmentToggle() {

        this.setState(prevState => ({ installmentModal: !prevState.installmentModal, isOpen: false }));
    }

    compareArray(arr1, arr2, a, b) {
        return arr1.filter(x => {
            return arr2.some(y => x[a] === y[b]);
        });
    }

    formOnSubmitMiddleware = values => {
        let check = this.checkEditValues(values.merchantCommissionInstallmentDefs);
        if (check) {
            this.setState({ approveModal: true, values: values });
        }
        else {
            this.installmentToggle();
        }

    };

    handleValidInstallmentCommissionRecordSubmit = () => {
        const { onAddMerchantCommissionRecords, onUpdateMerchantCommissionRecords } = this.props;
        const { values, isEdit, radioValue } = this.state;
        values.updateUser = localStorage.getItem("username");
        values.userName = localStorage.getItem("username");
        // values.merchantGuid = localStorage.getItem("guid");
        if (isEdit) {
            values.status = radioValue;
            onUpdateMerchantCommissionRecords(values);
        } else {
            values.guid = 0;
            onAddMerchantCommissionRecords(values);
        }
        this.setState({ approveModal: false, values: [] });
        this.installmentToggle();
    };

    childToParentProps = ([newData], oldData) => {
        oldData.forEach(item => {
            item.currencyGuid = this.props.currencyDefRecordList.find(x => x.alphabeticCode === "TRY").guid;
            this.tableChangedData.current.set(item.installmentId, item);

        });
        this.tableChangedData.current.set(newData.installmentId, newData);
    };

    dataTableDataFill(record) {
        const newKeyList = {};

        let tl = this.props.currencyDefRecordList.find(x => x.alphabeticCode === "TRY").guid
        let usd = this.props.currencyDefRecordList.find(x => x.alphabeticCode === "USD").guid
        let eur = this.props.currencyDefRecordList.find(x => x.alphabeticCode === "EUR").guid
        let rub = this.props.currencyDefRecordList.find(x => x.alphabeticCode === "RUB").guid
        let gbp = this.props.currencyDefRecordList.find(x => x.alphabeticCode === "GBP").guid
        localStorage.setItem("payFacCommissionInstallmentDefs", JSON.stringify(record.payFacCommissionInstallmentDefs));

        let payFacCommissionInstallmentDefs = JSON.parse(localStorage.getItem("payFacCommissionInstallmentDefs"));
        let intallmentOneTry = payFacCommissionInstallmentDefs.find(x => x.installmentId == 1 && x.currencyGuid == tl)
        let intallmentOneCurrency = payFacCommissionInstallmentDefs.find(x => x.installmentId == 1 && x.currencyGuid == usd)
        if (intallmentOneCurrency != undefined) {
            intallmentOneTry.installmentRateUsd = intallmentOneCurrency.installmentRate;
            let usdIndex = payFacCommissionInstallmentDefs.indexOf(payFacCommissionInstallmentDefs.find(x => x.installmentId == 1 && x.currencyGuid == usd))
            if (usdIndex > -1) payFacCommissionInstallmentDefs.splice(usdIndex, 1);
            let eurIndex = payFacCommissionInstallmentDefs.indexOf(payFacCommissionInstallmentDefs.find(x => x.installmentId == 1 && x.currencyGuid == eur))
            if (eurIndex > -1) payFacCommissionInstallmentDefs.splice(eurIndex, 1);
            let rubIndex = payFacCommissionInstallmentDefs.indexOf(payFacCommissionInstallmentDefs.find(x => x.installmentId == 1 && x.currencyGuid == rub))
            if (rubIndex > -1) payFacCommissionInstallmentDefs.splice(rubIndex, 1);
            let gbpIndex = payFacCommissionInstallmentDefs.indexOf(payFacCommissionInstallmentDefs.find(x => x.installmentId == 1 && x.currencyGuid == gbp))
            if (gbpIndex > -1) payFacCommissionInstallmentDefs.splice(gbpIndex, 1);
        }

        let i = 0;
        payFacCommissionInstallmentDefs.forEach(item => {
            item.id = i;
            item.guid = item.merchantCommissionInstallmentGuid;
            item.payFacInstallmentRate = (currencyFormatControl(item.payFacInstallmentRate)).toString();
            item.reflectToMerchantCommissionRate = item.merchantInstallmentRate == 0 ? "0.00" : (currencyFormatControl(item.merchantInstallmentRate)).toString();
            item.installmentRate = item.merchantInstallmentRate == 0  ? undefined : (currencyFormatControl(item.merchantInstallmentRate)).toString();
            item.reflectToMerchantCommissionAmount = this.getReflectToMerchantCommissionAmount(item.reflectToMerchantCommissionRate);

            item.transferToAccountAmountTL = this.getTransferToAccountAmountTL(item.reflectToMerchantCommissionRate, item.reflectToMerchantCommissionAmount, item.payFacInstallmentRate);
            if (item.installmentRateUsd != undefined) item.installmentRateUsd = (currencyFormatControl(item.installmentRateUsd)).toString();
            i++;
        });
        payFacCommissionInstallmentDefs.forEach(item => {
            newKeyList[item.id] = item;

        });

        this.lastUpdateData.current = newKeyList;
        const newDataList = {};
        payFacCommissionInstallmentDefs.forEach(item => {

            newDataList[item.id] = item;
        });
        localStorage.setItem("payFacCommissionInstallmentDefs", JSON.stringify([]));
        return Object.keys(newDataList || {}).map(key => ({
            ...(newDataList[key] || {
                id: key
            }),
        }));
    }

    cellEditorSelector(e) {
        return {
            component: "agRichSelectCellEditor",
            params: {
                values: this.state.currency.map(x => x.guid),
            },
            popup: true,
        };
    }

    cellEditValidation = (data) => {
        data.payFacInstallmentRate = currencyFormatControl(data.payFacInstallmentRate);
        data.reflectToMerchantCommissionRate = currencyFormatControl(data.reflectToMerchantCommissionRate);
        data.installmentRate = data.reflectToMerchantCommissionRate != "0.00" ? data.reflectToMerchantCommissionRate : "0.00";
        data.reflectToMerchantCommissionAmount = this.getReflectToMerchantCommissionAmount(data.installmentRate);
        data.transferToAccountAmountTL = this.getTransferToAccountAmountTL(data.installmentRate, data.reflectToMerchantCommissionAmount, data.payFacInstallmentRate);
        return data;
    }

    onChangeRadioButton = (e, data) => {
        this.setState({ radioValue: e });
    }

    getTransferToAccountAmountTL(reflectToMerchantCommissionRate, reflectToMerchantCommissionAmount, payFacInstallmentRate) {

        if (reflectToMerchantCommissionRate == "0.00") {
            return (parseFloat(reflectToMerchantCommissionAmount) - parseFloat(payFacInstallmentRate)).toFixed(2)
        }
        else {
            let cr = (parseFloat(reflectToMerchantCommissionAmount) * parseFloat(payFacInstallmentRate)).toFixed(2);
            cr = (cr / 100).toFixed(2);
            return (parseFloat(reflectToMerchantCommissionAmount) - cr).toFixed(2);
        }
    }

    getReflectToMerchantCommissionAmount(reflectToMerchantCommissionRate) {

        if (reflectToMerchantCommissionRate == "0.00") {
            return parseFloat("100.00").toFixed(2);
        }
        else {
            return (parseFloat("100.00") + parseFloat(reflectToMerchantCommissionRate)).toFixed(2);
        }

    }

    checkEditValues(data) {

        let find = data.find(p => p.installmentRate !== undefined);
        return find !== null && find !== undefined ? true : false;
    }

    render() {
        const { recordList, loading, loadingCurrencyRecordList, loadingBankRecordList } = this.props;
        const { record, error, approveModal } = this.state;

        return (
            <React.Fragment>
                {error && (
                    <ErrorModal
                        errorMessage={error}
                        onCloseModalClick={() => this.setState({ error: undefined })}
                    />
                )}
                <ToastContainer />
                <ApproveModalWithParams
                    show={approveModal}
                    onClick={this.handleValidInstallmentCommissionRecordSubmit}
                    customMessage={this.props.t("merchantCommissionUpdateQuestion")}
                    onCloseClick={() => this.setState({ approveModal: false })}
                />
                {loading || loadingBankRecordList || loadingCurrencyRecordList ? (
                    <Spinner className="position-absolute top-50 start-50 primary" />
                ) : (
                    <div className="page-content">
                        <Container fluid>
                            <Row>
                                <Col xs="12">
                                    <Card>
                                        <CardBody>
                                            <RavenAgTable
                                                onDynamicFunction={this.handleCommissionDefClick}
                                                dynamicFunctionName={this.props.t("merchantCommissionListDetail")}
                                                dynamicFunctionIcon={"mdi mdi-table-plus font-size-16 text-primary me-1"}
                                                actionItems={true}
                                                exportOption={false}
                                                recordcolumns={this.state.recordcolumns}
                                                recordList={recordList}
                                                breadCrumbTitle={this.props.t("installmentAndCommissionManagement")}
                                                breadCrumbItem={this.props.t("merchantCommissionList")}
                                                loading={loading || loadingBankRecordList || loadingCurrencyRecordList}
                                            />
                                            {this.state.installmentModal && (
                                                <MerchantCommissionForm
                                                    isOpen={this.state.installmentModal}
                                                    className={this.state.props}
                                                    isEdit={true}
                                                    isDetail={this.state.radioValue}
                                                    newData={newData}
                                                    agModalColumns={
                                                        this.state.bankCommissionrecordcolumns
                                                    }
                                                    record={record}
                                                    formOnSubmitMiddleware={this.formOnSubmitMiddleware}
                                                    toggle={this.installmentToggle}
                                                    form={this.form}
                                                    childToParentProps={this.childToParentProps}
                                                    formSubmitButtonRef={this.formSubmitButtonRef}
                                                    t={this.props.t}
                                                    recordBankList={this.props.recordBankList}
                                                    cellEditValidation={this.cellEditValidation}
                                                    radioButtonValue={this.state.radioValue}
                                                    handleRadioButton={this.onChangeRadioButton}
                                                />
                                            )}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </div>)}
            </React.Fragment>
        );
    }
}

MerchantCommissionList.propTypes = {
    recordList: PropTypes.array,
    onGetRecordList: PropTypes.func,
    className: PropTypes.any,
    apiError: PropTypes.any,
    apiInstallmentError: PropTypes.any,
    error: PropTypes.any,
    recordBankList: PropTypes.array,
    currencyDefRecordList: PropTypes.array,
    onGetBankList: PropTypes.func,
    recordProgramList: PropTypes.array,
    t: PropTypes.any,
    onAddMerchantCommissionRecords: PropTypes.func,
    onUpdateMerchantCommissionRecords: PropTypes.func,
    onGetCurrencyRecordList: PropTypes.func,
    loading: PropTypes.bool,
    loadingCurrencyRecordList: PropTypes.bool,
    loadingBankRecordList: PropTypes.bool,
    loadingBankNetworkRecordList: PropTypes.bool,
};

const mapStateToProps = ({
    domesticBankDefinition,
    currencyDefinition,
    merchantCommissionList
}) => ({
    loadingCurrencyRecordList: currencyDefinition.currencyLoading,
    loadingBankRecordList: domesticBankDefinition.loadingDomesticBankListByPricingTableGuid,
    loading: merchantCommissionList.loading,
    recordList: merchantCommissionList.recordList,
    recordBankList: domesticBankDefinition.recordList,
    currencyDefRecordList: currencyDefinition.recordList,
    error: merchantCommissionList.error,
});

const mapDispatchToProps = dispatch => ({
    onGetRecordList: record => dispatch(getPayFacCommissionsByPricingTableGuidAndMerchantGuid(record)),
    onGetBankList: (record) => dispatch(getPayFacCommissionBankListByUserName(record)),
    onAddMerchantCommissionRecords: record => dispatch(insertMerchantCommissions(record)),
    onUpdateMerchantCommissionRecords: record => dispatch(updateMerchantCommissions(record)),
    onGetCurrencyRecordList: () => dispatch(getCurrencyListSync()),
    apiError: error => dispatch(merchantCommissionListApiError(error)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation()(MerchantCommissionList));
